module.exports = __webpack_public_path__ + "img/EK Dant Logo.b9a91a77.jpg";